import React, { useEffect, useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton } from '@material-ui/core'
import './UnavailableStatePopup.scss'

export const UnavailableStatePopup = ({ title, body, open, onCancel }) => {
  const handleClose = () => {
    onCancel && onCancel()
  }

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="unavailable-state-modal"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.open('https://www.voominsurance.com/')} color="primary" className="continue-button">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}
